module.exports = __webpack_public_path__ + "img/10.7a2dd0e8.png";